import React from "react";

type AdminWelcomeHeaderProps = {
  firstName: string;
};

const AdminWelcomeHeader: React.FC<AdminWelcomeHeaderProps> = ({
  firstName,
}) => {
  return (
    <div className="admin-home-welcome">
      <div className="admin-home-welcome__text">
        <h1 className="admin-home-welcome__title">
          Welcome{firstName ? `, ${firstName}` : ""}
        </h1>
        <p className="admin-home-welcome__subtitle">
          Manage your partner ecosystem
        </p>
      </div>
    </div>
  );
};

export default AdminWelcomeHeader;
